@if (show()) {
  <header class="navbar-logo">
    <div class="navbar-logo__wrapper">
      <img
        class="navbar-logo__main-logo"
        src="assets/images/logo-vale-saude.svg"
        alt="Vale Saúde"
        width="154"
        height="32"
        loading="eager"
      />

      <div class="navbar-logo__end">
        <app-text size="xxsm" sizeDesktop="sm" color="dark" lineHeight="100%">uma empresa</app-text>

        <img src="assets/images/logo-vivo.svg" alt="Vivo" width="53" height="18" loading="eager" />
      </div>
    </div>
  </header>
}
